import { useFormEditor } from "../../../../../../hooks/checklist-hooks";
import ChecklistYesNoInputBuilder from "./ChecklistYesNoInputBuilder";

interface Props {
  className?: string;
  closeForm: () => void;
}

const ChecklistYesNoInputCreator = (props: Props) => {
  const ctx = useFormEditor();

  return (
    <ChecklistYesNoInputBuilder
      closeForm={props.closeForm}
      onSubmit={(values) => {
        ctx.controls.addElement({ element: values });
        props.closeForm();
      }}
    />
  );
};

export default ChecklistYesNoInputCreator;
